export const ADD_USER_START = 'ADD_USER_START';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';
export const ADD_USER_LOADING = 'ADD_USER_LOADING';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const CLEAR_ADD_USER = 'CLEAR_ADD_USER';
